export const SUMMARY_SOURCE = {
  CART: 'cart',
  ORDER: 'order',
  SALE: 'sale',
  SALE_CHANGE: 'saleChange',
  DIRECT_LINK: 'directLink',
} as const;
